module.exports = __webpack_public_path__ + "img/widex-tv-play-1000-1000.d36c1d83e34ae224dc3e1632b9e51fe8.png";